import { WithLoader } from '../Hoc/WithLoader/WithLoader.jsx';
// Internal Imports
import { ContentList } from './ContentList.jsx';

// Local Variables
const ContentListWithLoader = WithLoader(ContentList);

// Module Exports
export { ContentListWithLoader };
